export function splitIntoChunk(arr: unknown[], chunk: number) {
  const res = [];

  for (let i = 0; i < arr.length; i += chunk) {
    res.push(arr.slice(i, i + chunk));
  }

  return res;
}
